import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaPhone, FaWhatsapp } from 'react-icons/fa';
import './FloatingContact.css';

const FloatingContact = () => {
  const [callHover, setCallHover] = useState(false);
  const [whatsappHover, setWhatsappHover] = useState(false);

  const createBubbles = () => {
    return Array.from({ length: 8 }).map((_, index) => (
      <span key={index} className="bubble" style={{ '--i': index }}></span>
    ));
  };

  return (
    <div className="floating-contact">
      <motion.a
        href="tel:+919791177445"
        className="contact-button call-button"
        initial={{ opacity: 0, x: 100 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        whileHover={{ scale: 1.15 }}
        whileTap={{ scale: 0.95 }}
        title="Call Us"
        onMouseEnter={() => setCallHover(true)}
        onMouseLeave={() => setCallHover(false)}
      >
        <FaPhone className="contact-icon" />
        {callHover && <div className="bubbles-container">{createBubbles()}</div>}
      </motion.a>

      <motion.a
        href="https://wa.me/919791177445?text=Hello%20Prime%20Crown%20Assets!%0A%0AI%20am%20interested%20in%20your%20real%20estate%20and%20construction%20services%20in%20Coimbatore.%0A%0APlease%20provide%20me%20more%20information%20about%3A%0A-%20DTCP%20Approved%20Layouts%0A-%20Building%20Construction%0A-%20Land%20Sale%20%26%20Purchase%0A%0AThank%20you!"
        target="_blank"
        rel="noopener noreferrer"
        className="contact-button whatsapp-button"
        initial={{ opacity: 0, x: 100 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5, delay: 0.4 }}
        whileHover={{ scale: 1.15 }}
        whileTap={{ scale: 0.95 }}
        title="WhatsApp"
        onMouseEnter={() => setWhatsappHover(true)}
        onMouseLeave={() => setWhatsappHover(false)}
      >
        <FaWhatsapp className="contact-icon" />
        {whatsappHover && <div className="bubbles-container">{createBubbles()}</div>}
      </motion.a>
    </div>
  );
};

export default FloatingContact;
